import React from "react";
// import { Link } from 'react-router-dom';
const slider = () => {
    return (

        <section className="hero hero-slider-wrapper ">
            <div className="hero-slider hero-slider-style-1">
                <div className="slide">
                    <img src="assets/images/slider/slide-1.jpg" alt='' role='presentation' className="slider-bg" />
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-8 col-sm-9 slide-caption">
                                <h2>تولید ایرانی ، کیفیت جهانی</h2>
                                <p>با بها بخشیدن به تولید ایرانی، کشورمان را سرآمد تکنولوژی دنیا سازیم.</p>
                                <div className="btns">
                                    {/* <Link to="/about" className="theme-btn">درباره ما</Link> */}
                                    {/* <Link to="#" className="theme-btn-s2">کاوش</Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="slide">
                    <img src="assets/images/slider/slide-2.jpg" alt='' role='presentation' className="slider-bg" />
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-8 col-sm-9 slide-caption">
                                <h2>طراحی اصولی و منحصر بفرد</h2>
                                <p>با اصول مهندسی و استاندارد یک صنعت منحصر به فرد و پیشرو در تکنولوژی خواهید داشت.</p>
                                <div className="btns">
                                    {/* <Link to="#" className="theme-btn">درباره ما</Link> */}
                                    {/* <Link to="#" className="theme-btn-s2">کاوش</Link> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="slide">
                    <img src="assets/images/slider/slide-3.jpg" alt='' role='presentation' className="slider-bg" />
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-8 col-sm-9 slide-caption">
                                <h2><span>آپافن</span>، فناوری نوین نساجی</h2>
                                <p>یک نوآوری قابل رقابت با فن آوری روز دنیا ، ثمربخش و مطلوب هر صنعت رو به پیشرفت خواهد بود.</p>
                                <div className="btns">
                                    {/* <Link to="#" className="theme-btn">درباره ما</Link> */}
                                    {/* <Link to="#" className="theme-btn-s2">کاوش</Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    );
};

export default slider;